import { useArtifactsStore, type Artifact } from '@/stores/artifactsStore'
import { useChatStore } from '@/stores/chatStore'

type InsightArtifact = Extract<Artifact, { type: 'insights' }>
let observingConversations = false

function observeConversations() {
  if (observingConversations) return
  useChatStore.subscribe((next, previous) => {
    if (
      next.activeConversationId !== previous.activeConversationId &&
      useArtifactsStore.getState().active?.type === 'insights'
    )
      useArtifactsStore.getState().close()
  })
  observingConversations = true
}

/** The stream captures its conversation before navigation can change it. */
export function openInsightsForConversation(artifact: InsightArtifact) {
  observeConversations()
  if (
    artifact.source?.conversationId &&
    artifact.source.conversationId !== useChatStore.getState().activeConversationId
  )
    return
  useArtifactsStore.getState().open(artifact)
}
